module.exports = __webpack_public_path__ + "img/prfx.a5cff05d.png";